import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import List from './List/List';
import Search from './Search/Search';

@connect((store) => {
  return {
    common: store.common,
    loggedUser: store.loggedUser,
  };
})
class Account extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      list: [],
      sections: {
        companies: {
          id: 'company',
          label: 'Companies',
          singular: 'Company',
          icon: <i class="material-icons">business</i>,
        },
        projects: {
          id: 'project',
          label: 'Projects',
          singular: 'Project',
          icon: <i class="material-icons">card_travel</i>,
        },
      },
    };

    _.map(['onOverlay', 'onUpdateList'], (fn) => {
      this[fn] = this[fn].bind(this);
    });
  }

  onOverlay(e) {
    const { dispatch } = this.props;

    e.preventDefault();

    dispatch({ type: 'COMMON_UPDATE_SIDEPANEL_STATUS', status: 'overlay' });
  }

  onUpdateList(list) {
    this.setState({
      ...this.state,
      list,
    });
  }

  render() {
    const { common, loggedUser } = this.props;

    return (
      <div id="menu-accounts">
        <div class="divider"></div>
        <div class="accounts-search">
          {common.sidepanelStatus === 'icon-only' ? (
            <a href="/" onClick={this.onOverlay}>
              <i class="material-icons">search</i>
            </a>
          ) : (
            <Search />
          )}
        </div>
        <div class="divider"></div>
        <div
          class={`accountListContainer ${loggedUser.data.userRole <= 2 ? 'settings-terms-enabled' : ''}`}
        >
          {Object.keys(this.state.sections)
            .filter(
              (k) =>
                (loggedUser.data.userRole > 4 && k !== 'projects') ||
                loggedUser.data.userRole < 5
            )
            .map((k) => (
              <List
                section={this.state.sections[k]}
                keyword={this.state.keyword}
                history={this.props.history}
              />
            ))}
        </div>
      </div>
    );
  }
}

export default Account;
